<template>
    <div class="newsletter-form-container">
        <span>{{ $t('home.newsletter') }}</span>
        <div class="input-container">
            <div class="input-container-inner">
                <input :placeholder="$t('home.newsletter-your-email')" v-model="email">
                <a @click="submit">{{ $t('home.newsletter-i-register') }}</a>
            </div>
            <div class="input-legend">{{ $t('home.newsletter-confidentiality') }}</div>
        </div>
        <div class="social-container">
            <span>{{ $t('home.newsletter-follow-us') }}</span>
            <!--
            <a href="https://www.facebook.com/pg/openfly.fr" target="_blank">
                <img src="/imgs/facebook.svg">
            </a>
            <a href="https://twitter.com/openfly_fr" target="_blank">
                <img src="/imgs/twitter.svg">
            </a>
            -->
            <a href="https://www.linkedin.com/company/openfly" target="_blank">
                <img src="/imgs/linkedin.svg">
            </a>
        </div>

        <div class="newsletter-modal-container" v-if="!!message">
            <div class="newsletter-modal">
                <p>{{ message }}</p>
                <div class="actions">
                    <div class="spacer"></div>
                    <a class="md-button md-button md-raised md-primary md-theme-default md-theme-default" @click="message = ''">
                        <div class="md-ripple">
                            <div class="md-button-content">
                                {{ $t('global.close') }}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            messageType: 'info',
            message: '',
            submitting: false,
        };
    },

    methods: {
        submit() {
            if (!this.submitting) {
                this.submitting = true;
                axios.post('/api/newsletter-registration', {email: this.email})
                    .then(() => {
                        this.messageType = 'info';
                        this.message = this.$t('home.newsletter-registration-confirmation');
                        this.email = '';
                        this.submitting = false;
                    })
                    .catch((error) => {
                        this.messageType = 'error';
                        this.message = error.response.data.errors.email[0];
                        this.submitting = false;
                    });
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.newsletter-form-container {
    input {
        font-size: 11px;
        color: #273B64;
    }
}
.newsletter-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    background-color: #8080809e;
    .newsletter-modal {
        background-color: white;
        color: #273B64;
        padding: 20px;
        font-size: 12px;
        border-radius: 5px;
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.05), 0 4px 5px 0 rgba(0, 0, 0, 0.05), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
        z-index: 1000;
        .actions {
            display: flex;
            align-items: center;
            border-top: solid 1px;
            padding: 10px 0 0 0;
            .spacer {
                flex-grow: 1;
            }
            a {
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/NewsletterRegistrationForm.vue